export const handleQueryStrings = () => {
    let offer = false;

    let ppcid = '7';
    let cid = 'RateZip';
    let gclid = '';
    let tsid = 'RateZip';
    let phoneNumber = '855-517-0091';
    let changeHeadline = false;
    let isPurchase = false;
    let isCobrand = false;

    const fullUrl = window.location.href;
    const query = new URLSearchParams(window.location.search);
    let fullQueryString = '?' + query.toString();

    if (fullUrl.includes('/lb')) {
        offer = true;
    }

    if (fullUrl.includes('/xlt')) {
        phoneNumber = '855-931-4803';

        const style = query.get('style') || '';
        if (style === 'new') {
            changeHeadline = true;
        }
    }

    if (fullUrl.includes('/for-purchase')) {
        isPurchase = true;
    }

    if (fullQueryString.length > 1) {
        cid = query.get('cid') || cid;
        gclid = query.get('gclid') || '';

        ppcid = query.get('ppcid') || ppcid;

        if (gclid.length > 0 && !ppcid) {
            ppcid = '7732';
            cid = gclid;
        }

        const fbclid = query.get('fbclid');

        if (fbclid) {
            cid = fbclid;
        }

        tsid = query.get('tsid') || 'RateZip';
    }

    if (ppcid === '1899') {
        isCobrand = true;
    }

    const queryObject = {
        ppcid,
        cid,
        tsid,
        gclid,
        offer,
        fullQueryString,
        phoneNumber,
        changeHeadline,
        isPurchase,
        isCobrand
    };

    return queryObject;
};
